// Lazy initialization of Stripe to handle cases where it hasn't loaded yet
let stripeInstance = null;

const getStripe = () => {
  if (stripeInstance) {
    return stripeInstance;
  }

  // Check if Stripe is available
  if (typeof window !== 'undefined' && window.Stripe) {
    try {
      stripeInstance = window.Stripe(process.env.STRIPE_PUBLIC_KEY);
      return stripeInstance;
    } catch (error) {
      console.error('Error initializing Stripe:', error);
      return null;
    }
  }

  // If Stripe is not available, return null
  console.warn('Stripe is not loaded yet. Make sure the Stripe script is included in your HTML.');
  return null;
};

export default getStripe;
